import React from 'react';

import {
  formatDateToDDMMYYYY,
  formatDateToYYYYMMDD,
  parseJournalApiDate,
  useFormatDate,
} from '../../../../utils';
import * as s from './DatePublished.css';

interface IDatePublished {
  /** Дата строкой вв ISO 8601 */
  children: string;
  /** Выводить ли текст Обновлено */
  isUpdated?: boolean;
}

/**
 * Дата публикации
 */
export const DatePublished = ({ children, isUpdated }: IDatePublished) => {
  const formatDate = useFormatDate();
  const date = parseJournalApiDate(children);

  return (
    <time className={s['wrapper']} dateTime={formatDateToYYYYMMDD(date)} title={formatDate(date)}>
      {`${isUpdated ? 'Обновлено ' : ''}${formatDateToDDMMYYYY(date)}`}
    </time>
  );
};
